module.exports = __webpack_public_path__ + "static/media/iconClose.5b3b1cf9.svg";